.divbarWrap {
	position: absolute;
	.divBar {
		position: relative;
		top: -9px;
		z-index: 10;
		img {
			min-height: 18px;
			width: 100vw;
			max-width: 100%;
			position: relative;
		}
	}
}
@media screen and (min-width: 768px) {
	.divbarWrap {
		.divBar {
			top: -6px;
			img {
				min-height: 12px;
			}
		}
	}
}
@media screen and (min-width: 1024px) {
	.divbarWrap {
		.divBar {
			img {
				min-height: 12px;
			}
		}
	}
}
